
<router-outlet></router-outlet>
<!-- 
@if (whichLayout == 'master') {
  <app-master-layout></app-master-layout>
}

@if (whichLayout == 'open') {
  <app-open-layout></app-open-layout>
}

@if (whichLayout == 'terminal') {
  <app-terminal-layout></app-terminal-layout>
}

@if (whichLayout == 'merchant-admin') {
  <app-merchant-admin-layout></app-merchant-admin-layout>
}

@if (whichLayout == 'merchant') {
  <app-merchant-layout></app-merchant-layout>
} -->
